module.exports = __webpack_public_path__ + "3130b4101f73fa48b9aba6765175bf2b.png";